module.exports = __webpack_public_path__ + "static/media/Slider1.95c6dfe5.jpg";